import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type I21OdezaChatProps = RenderingProps<I21OdezaChatFields, I21OdezaChatParams>;

export type I21OdezaChatFields = {
  APIKey?: Field<string>;
  OdezaSource?: KeyValuePair;
};

export type I21OdezaChatParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
